import { render, staticRenderFns } from "./PurchasesAmount.vue?vue&type=template&id=0f427ef0"
import script from "./PurchasesAmount.vue?vue&type=script&lang=js"
export * from "./PurchasesAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports